module.exports = __webpack_public_path__ + "img/flag_hr.9747aa2.svg";